import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">热门话题</h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">全网热议 · 实时更新话题热度</p>
        <div className="flex flex-wrap gap-3">
          {topicsData.map((item, i) => (
            <a key={i} href="#cards" className="group flex items-center gap-3 bg-background-50 hover:bg-background-200/60 border border-background-200/60 hover:border-primary-500/25 rounded-full px-4 py-2.5 transition-all cursor-pointer">
              <span className="text-sm font-medium text-foreground-300 group-hover:text-primary-400 transition-colors whitespace-nowrap">{item.name}</span>
              <span className="text-xs text-accent-400 font-medium whitespace-nowrap">{item.heat}</span>
              <i className="ri-arrow-right-line text-xs text-foreground-600 group-hover:text-primary-400 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}